<template>
  <div>
    <!-- ═══ PANEL FLOTANTE ═══ -->
    <transition name="menu-slide">
      <div
        v-if="selectedRow"
        class="menu-flotante"
        :style="menuStyle"
        @click.stop
      >
        <div class="menu-header">
          <span class="menu-titulo">Acciones</span>
          <button class="menu-cerrar" @click="cerrarMenu">✕</button>
        </div>

        <div class="menu-codigo">Detalle #{{ selectedRow.id_pedido_pago_detalle }}</div>

        <div class="menu-items">
          <!--DETALLE ABIERTO (estado == 2)-->
          <template v-if="selectedRow.estado == 2">
            <button class="menu-item menu-item--cerrar" @click="detalleSelected=selectedRow; confirmCerrarDetalle(selectedRow); cerrarMenu()">
              <span class="menu-item-icono"><i class="feather icon-check"></i></span>
              <span class="menu-item-texto">
                <strong>Cerrar Detalle</strong>
                <small>Marcar como cerrado</small>
              </span>
            </button>
            <button class="menu-item menu-item--editar" @click="detalleSelected=selectedRow; f_preEditar(); cerrarMenu()">
              <span class="menu-item-icono"><i class="feather icon-edit"></i></span>
              <span class="menu-item-texto">
                <strong>Editar</strong>
                <small>Modificar detalle</small>
              </span>
            </button>
            <button class="menu-item menu-item--eliminar" @click="detalleSelected=selectedRow; popupConfirmDelete=true; cerrarMenu()">
              <span class="menu-item-icono"><i class="feather icon-x-square"></i></span>
              <span class="menu-item-texto">
                <strong>Eliminar</strong>
                <small>Eliminar detalle</small>
              </span>
            </button>
          </template>
          <!--DETALLE CERRADO (estado == 1)-->
          <template v-if="selectedRow.estado == 1">
            <button class="menu-item menu-item--reabrir" @click="detalleSelected=selectedRow; confirmReabrirDetalle(selectedRow); cerrarMenu()">
              <span class="menu-item-icono"><i class="feather icon-settings"></i></span>
              <span class="menu-item-texto">
                <strong>Reabrir Detalle</strong>
                <small>Volver a estado abierto</small>
              </span>
            </button>
          </template>
        </div>
      </div>
    </transition>

    <vs-alert class="mt-2">
      <p>Registre los detalles de pago asociados a este convenio. Cada detalle incluye un valor y una descripción.</p>
    </vs-alert>
    <div class="mt-2">
      <p class="text-lg mb-2">
        <b>Anticipo Global del Convenio:</b> {{ anticipo_global }}
      </p>
      <p class="text-xl">
        <b class="text-success">Total Detalle Pagos Cerrados:</b> {{ totalCerrados }}
      </p>
      <p v-if="totalAbiertos > 0" class="text-xl mt-1">
        <b class="text-danger">Total Detalle Pagos Abiertos:</b> {{ totalAbiertos }}
      </p>
      <vs-alert v-if="totalCerrados > anticipo_global" color="danger" class="mt-3">
        <template #icon>
          <i class="fas fa-exclamation-triangle"></i>
        </template>
        <b>¡Atención!</b> El total de detalles cerrados ({{ totalCerrados }}) supera el anticipo global del convenio ({{ anticipo_global }}) por <b>{{ (totalCerrados - anticipo_global).toFixed(2) }}</b>
      </vs-alert>
    </div>
    <div class="mt-5" v-if="groupFacturador || userRoot">
      <vs-button icon="add" class="mb-2 p-3" @click="f_limpiar(); title='Agregar detalle'; popupAdd=true;">Crear</vs-button>
    </div>

    <vs-table max-items="5" stripe search pagination :data="arrayDetalles">
      <template slot="header">
        <vs-chip color="primary">Cantidad: <b> {{ arrayDetalles.length }}</b></vs-chip>
      </template>
      <template slot="thead">
        <vs-th>Valor</vs-th>
        <vs-th>Descripción</vs-th>
        <vs-th v-if="groupFacturador || userRoot">Acciones</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p><b>Valor:</b> {{ tr.valor }}</p>
            <div v-if="tr.forma_pago_nombre" class="mt-2">
              <b>Forma de Pago:</b>
              <p>{{ tr.forma_pago_nombre }}</p>
            </div>
            <b>Fecha creación:</b>
            <p>{{ tr.created_at }}</p>
            <b>Creador:</b>
            <p>{{ tr.usuario_creador }}</p>
            <div v-if="tr.usuario_editor" class="mt-2">
              <b>Último Editor:</b>
              <p>{{ tr.usuario_editor }}</p>
            </div>
            <div v-if="tr.estado == 1 && tr.usuario_cierre_nombre" class="mt-3 p-2 bg-green-50 rounded border-l-4 border-green-500">
              <b class="text-success">Cerrado por:</b>
              <p>{{ tr.usuario_cierre_nombre }}</p>
              <b v-if="tr.fecha_proceso">Fecha:</b>
              <p v-if="tr.fecha_proceso">{{ tr.fecha_proceso }}</p>
            </div>
            <div v-if="tr.estado == 2 && tr.usuario_abre_nombre" class="mt-3 p-2 bg-red-50 rounded border-l-4 border-red-500">
              <b class="text-danger">Reabierto por:</b>
              <p>{{ tr.usuario_abre_nombre }}</p>
              <b v-if="tr.fecha_proceso">Fecha:</b>
              <p v-if="tr.fecha_proceso">{{ tr.fecha_proceso }}</p>
            </div>
            <div class="mt-3">
              <b>Estado:</b> <br>
              <vs-chip :color="tr.estado == 1 ? 'success' : 'danger'" class="ml-2">
                {{ tr.estado == 1 ? 'Cerrado' : 'Abierto' }}
              </vs-chip>
            </div>
          </vs-td>
          <vs-td>
            {{ data[indextr].descripcion }}
          </vs-td>
          <vs-td align="center" v-if="groupFacturador || userRoot">
            <button
              class="menu-trigger-btn"
              :class="{ active: selectedRow && selectedRow.id_pedido_pago_detalle === tr.id_pedido_pago_detalle }"
              @click.stop="toggleMenu(tr, $event)"
              title="Acciones"
            >⋮</button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- Modal crear/editar -->
    <vs-popup classContent="popup-example" :title="title" :active.sync="popupAdd" class="informacionformhijo">
      <div v-if="popupAdd">
        <div class="vx-row">
          <div class="vx-col w-full">
            <small>Valor:</small>
            <vs-input v-model="datos.valor" class="w-full" @input="datos.valor = limpiarValorNumerico(datos.valor)"></vs-input>
          </div>
          <div class="vx-col w-full mt-5">
            <small>Forma de Pago: <span class="text-danger">*</span></small>
            <v-select 
              :options="arrayFormasPago" 
              :reduce="fp => fp" 
              label="tip_pag_nombre" 
              placeholder="--Seleccione--" 
              class="w-full" 
              v-model="datos.forma_pago" 
            />
          </div>
          <div class="vx-col w-full mt-5">
            <small>Descripción:</small>
            <vs-textarea counter="500" :counter-danger.sync="counterDanger" height="200px" label="Descripción" v-model="datos.descripcion" />
          </div>
        </div>
        <div class="flex justify-center mt-5">
          <vs-button @click="f_guardarDetalle()" class="m-2" icon="check">Guardar</vs-button>
          <vs-button @click="popupAdd=false" type="border" color="warning" class="m-2" icon="close">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Modal confirmar eliminar -->
    <vs-popup classContent="popup-example" title="Eliminar" :active.sync="popupConfirmDelete" class="informacionformhijo">
      <div v-if="popupConfirmDelete">
        <p class="text-center font-bold text-2xl">¿Estás seguro de eliminar?</p>
        <div class="flex justify-center mt-5">
          <vs-button @click="f_eliminarDetalle()" class="m-2" icon="check">Sí, deseo eliminar</vs-button>
          <vs-button @click="popupConfirmDelete=false" type="border" color="warning" class="m-2" icon="close">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select'

export default {
  name: 'ConvenioDetalles',
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      usuario: [],
      arrayDetalles: [],
      arrayFormasPago: [],
      popupAdd: false,
      popupConfirmDelete: false,
      id: 0,
      datos: {
        valor: 0,
        descripcion: '',
        estado: 2, // Por defecto abierto (2)
        forma_pago: null,
      },
      detalleSelected: '',
      title: 'Agregar detalle',
      counterDanger: false,
      // menú flotante
      selectedRow: null,
      menuPos: { top: 0, left: 0 },
    }
  },
  props: {
    id_convenio: {
      type: Number,
      default: 0
    },
    groupFacturador: {
      type: Boolean,
      default: false
    },
    userRoot: {
      type: Boolean,
      default: false
    },
    anticipo_global: {
      type: Number,
      default: 0
    },
    formasPago: {
      type: Array,
      default: function() {
        return []
      }
    },
  },
  mounted() {
    this.usuario = JSON.parse(localStorage.getItem('usuario'))
    // Solo cargar formas de pago si no vienen por prop
    if (this.formasPago && this.formasPago.length > 0) {
      this.arrayFormasPago = this.formasPago
    } else {
      this.f_getFormasPago()
    }
    window.addEventListener('keydown', this.onKeydown)
    window.addEventListener('click', this.onClickFuera)
    window.addEventListener('scroll', this.cerrarMenu, true)
    window.addEventListener('resize', this.cerrarMenu)
  },
  watch: {
    id_convenio: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal > 0) {
          this.f_getDetalles()
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
    window.removeEventListener('click', this.onClickFuera)
    window.removeEventListener('scroll', this.cerrarMenu, true)
    window.removeEventListener('resize', this.cerrarMenu)
  },
  computed: {
    totalValor() {
      return this.arrayDetalles.reduce((sum, item) => sum + Number(item.valor), 0)
    },
    totalCerrados() {
      return this.arrayDetalles
        .filter(item => item.estado == 1)
        .reduce((sum, item) => sum + Number(item.valor), 0)
    },
    totalAbiertos() {
      return this.arrayDetalles
        .filter(item => item.estado == 2)
        .reduce((sum, item) => sum + Number(item.valor), 0)
    },
    menuStyle() {
      return {
        position: 'fixed',
        top: this.menuPos.top + 'px',
        left: this.menuPos.left + 'px',
        zIndex: 99999,
      }
    },
  },
  methods: {
    // ── Menú flotante ──────────────────────────────────────────────
    toggleMenu(row, event) {
      if (this.selectedRow && this.selectedRow.id_pedido_pago_detalle === row.id_pedido_pago_detalle) {
        this.cerrarMenu()
        return
      }
      const btn = event.currentTarget
      const rect = btn.getBoundingClientRect()
      const menuW = 244
      const pad = 8
      const vw = window.innerWidth
      let left = rect.right - menuW
      if (left < pad) left = pad
      if (left + menuW > vw - pad) left = vw - menuW - pad
      this.menuPos = { top: rect.bottom + pad, left }
      this.selectedRow = row
    },
    cerrarMenu() {
      this.selectedRow = null
    },
    onKeydown(e) {
      if (e.key === 'Escape') this.cerrarMenu()
    },
    onClickFuera(e) {
      if (!e.target.closest('.menu-trigger-btn') && !e.target.closest('.menu-flotante')) {
        this.cerrarMenu()
      }
    },
    limpiarValorNumerico(valor) {
      // Elimina todo lo que no sea número o punto decimal
      let limpio = String(valor).replace(/[^0-9.]/g, '')
      // Evita múltiples puntos
      const partes = limpio.split('.')
      if (partes.length > 2) {
        limpio = partes[0] + '.' + partes.slice(1).join('')
      }
      return limpio === '' ? '0' : limpio
    },
    f_getDetalles() {
      let me = this
      me.arrayDetalles = []
      me.$http.get(me.$server_url + `convenio?getDetallesConvenio=1&id_convenio=${me.id_convenio}`)
        .then(function (res) {
          if (!res.data || res.data.status == 0) return
          me.arrayDetalles = res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    f_getFormasPago() {
      let me = this
      me.$http.get(me.$server_url + `convenio?getFormasPago=1`)
        .then(function (res) {
          if (!res.data) return
          me.arrayFormasPago = res.data
          console.log('Formas de pago cargadas:', me.arrayFormasPago)
        })
        .catch(function (error) {
          console.log('Error al cargar formas de pago:', error)
        })
    },
    f_preEditar() {
      let me = this
      me.id                = me.detalleSelected.id_pedido_pago_detalle
      me.datos.valor       = me.detalleSelected.valor
      me.datos.descripcion = me.detalleSelected.descripcion
      me.datos.estado      = me.detalleSelected.estado
      me.datos.forma_pago  = me.arrayFormasPago.find(fp => fp.tip_pag_codigo == me.detalleSelected.forma_pago_id) || null
      me.title             = 'Editar detalle'
      me.popupAdd          = true
    },
    f_guardarDetalle() {
      let me = this
      if (Number(me.datos.valor) <= 0) {
        me.$vs.notify({ text: 'El valor debe ser mayor a 0', color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
        return
      }
      me.datos.descripcion = me.datos.descripcion.trim()
      if (me.datos.descripcion === '') {
        me.$vs.notify({ text: 'La descripción no puede estar vacía', color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
        return
      }
      if (me.datos.descripcion.length > 500) {
        me.$vs.notify({ text: 'La descripción no puede tener más de 500 caracteres', color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
        return
      }
      if (!me.datos.forma_pago) {
        me.$vs.notify({ text: 'Debe seleccionar una forma de pago', color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
        return
      }
      let formData = new FormData()
      formData.append('saveDetalleConvenio', 1)
      formData.append('id',             me.id)
      formData.append('id_usuario',     me.usuario.idusuario)
      formData.append('id_convenio',    me.id_convenio)
      formData.append('idConvenio',     me.id_convenio)
      formData.append('valor',          me.datos.valor)
      formData.append('descripcion',    me.datos.descripcion)
      formData.append('estado',         me.datos.estado)
      formData.append('forma_pago_id',  me.datos.forma_pago.tip_pag_codigo)
      me.$http.post(me.$server_url + `convenio`, formData)
        .then(function (res) {
          if (res.data.status == 0) {
            me.$vs.notify({ text: res.data.message, color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
            return
          }
          me.popupAdd = false
          me.f_getDetalles()
          me.$vs.notify({ text: me.id > 0 ? 'Detalle actualizado con éxito' : 'Detalle creado con éxito', color: 'success', iconPack: 'feather', icon: 'icon-check' })
          me.f_limpiar()
        })
        .catch(function (error) {
          me.popupAdd = false
          me.$vs.notify({ text: 'Error al guardar el detalle', color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
          console.log(error)
        })
    },
    f_eliminarDetalle() {
      let me = this
      let formData = new FormData()
      formData.append('eliminarDetalleConvenio', 1)
      formData.append('id',         me.detalleSelected.id_pedido_pago_detalle)
      formData.append('idConvenio', me.id_convenio)
      formData.append('id_usuario', me.usuario.idusuario)
      me.$http.post(me.$server_url + `convenio`, formData)
        .then(function (res) {
          if (res.data.status == 0) {
            me.$vs.notify({ text: res.data.message, color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
            return
          }
          me.popupConfirmDelete = false
          me.f_getDetalles()
          me.$vs.notify({ text: 'Detalle eliminado con éxito', color: 'success', iconPack: 'feather', icon: 'icon-check' })
        })
        .catch(function (error) {
          me.popupConfirmDelete = false
          me.$vs.notify({ text: 'Error al eliminar el detalle', color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle' })
          console.log(error)
        })
    },
    f_limpiar() {
      this.id = 0
      this.datos.valor = 0
      this.datos.descripcion = ''
      this.datos.estado = 2 // Reset a abierto (2)
      this.datos.forma_pago = null
    },
    // ── Cerrar/Reabrir Detalle ──────────────────────────────────────
    confirmCerrarDetalle(tr) {
      let me = this
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Confirmar`,
        acceptText: 'Sí, deseo cerrar el detalle',
        cancelText: 'Cancelar',
        text: '¿Estás seguro de cerrar este detalle de pago?',
        accept: this.cerrarDetalle
      })
    },
    cerrarDetalle() {
      let me = this
      let formData = new FormData()
      formData.append('cerrarDetalleConvenio', 1)
      formData.append('id', me.detalleSelected.id_pedido_pago_detalle)
      formData.append('id_usuario', me.usuario.idusuario)
      formData.append('idConvenio', me.id_convenio)
      me.$vs.loading()
      me.$http.post(me.$server_url + `convenio`, formData)
        .then(function (res) {
          me.$vs.loading.close()
          if (res.data.status == 0) {
            me.$vs.notify({ text: res.data.message, color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle', time: 5000 })
            return
          }
          me.$vs.notify({ text: 'Detalle cerrado correctamente', color: 'success', iconPack: 'feather', icon: 'icon-check' })
          me.f_getDetalles()
        })
        .catch(function () { me.$vs.loading.close() })
    },
    confirmReabrirDetalle(tr) {
      let me = this
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirmar`,
        acceptText: 'Sí, deseo reabrir el detalle',
        cancelText: 'Cancelar',
        text: '¿Estás seguro de reabrir este detalle de pago?',
        accept: this.reabrirDetalle
      })
    },
    reabrirDetalle() {
      let me = this
      let formData = new FormData()
      formData.append('reabrirDetalleConvenio', 1)
      formData.append('id', me.detalleSelected.id_pedido_pago_detalle)
      formData.append('id_usuario', me.usuario.idusuario)
      formData.append('idConvenio', me.id_convenio)
      me.$vs.loading()
      me.$http.post(me.$server_url + `convenio`, formData)
        .then(function (res) {
          me.$vs.loading.close()
          if (res.data.status == 0) {
            me.$vs.notify({ text: res.data.message, color: 'warning', iconPack: 'feather', icon: 'icon-alert-triangle', time: 5000 })
            return
          }
          me.$vs.notify({ text: 'Detalle reabierto correctamente', color: 'success', iconPack: 'feather', icon: 'icon-check' })
          me.f_getDetalles()
        })
        .catch(function () { me.$vs.loading.close() })
    },
  },
}
</script>

<style scoped>
.informacionformhijo {
  z-index: 51002;
}

/* ═══════════════════════════════════════════════════
   BOTÓN DISPARADOR  ⋮
═══════════════════════════════════════════════════ */
.menu-trigger-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #dde1e7;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #666;
  line-height: 1;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  user-select: none;
  flex-shrink: 0;
}
.menu-trigger-btn:hover,
.menu-trigger-btn.active {
  border-color: #6c63ff;
  background: #f3f1ff;
  box-shadow: 0 2px 10px rgba(108, 99, 255, 0.2);
  color: #6c63ff;
}

/* ═══════════════════════════════════════════════════
   PANEL FLOTANTE
═══════════════════════════════════════════════════ */
.menu-flotante {
  width: 244px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.10);
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.07);
}

.menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 8px;
  border-bottom: 1px solid #f0f0f0;
}
.menu-titulo {
  font-weight: 700;
  font-size: 12px;
  color: #1a1a2e;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}
.menu-cerrar {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #999;
  padding: 2px 6px;
  border-radius: 50%;
  transition: background 0.15s, color 0.15s;
}
.menu-cerrar:hover { background: #f0f0f0; color: #333; }

.menu-codigo {
  font-size: 10px;
  color: #888;
  padding: 4px 16px 10px;
  font-family: monospace;
  letter-spacing: 0.5px;
}

.menu-items {
  padding: 4px 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  background: transparent;
  text-align: left;
  transition: background 0.15s, transform 0.1s;
}
.menu-item:hover { transform: translateX(2px); }
.menu-item:active { transform: scale(0.98); }

.menu-item-icono {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}
.menu-item-texto {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.menu-item-texto strong { font-size: 13px; font-weight: 600; line-height: 1.2; }
.menu-item-texto small { font-size: 10.5px; opacity: 0.7; }

/* Cerrar — verde */
.menu-item--cerrar:hover { background: #e8f8f0; }
.menu-item--cerrar .menu-item-icono { background: #e0f5ea; color: #1a8a50; }
.menu-item--cerrar .menu-item-texto strong { color: #1a7a45; }
.menu-item--cerrar .menu-item-texto small { color: #2ecc71; }

/* Editar — naranja */
.menu-item--editar:hover { background: #fff3e0; }
.menu-item--editar .menu-item-icono { background: #ffecd0; color: #d35400; }
.menu-item--editar .menu-item-texto strong { color: #c0490a; }
.menu-item--editar .menu-item-texto small { color: #e67e22; }

/* Eliminar — rojo */
.menu-item--eliminar:hover { background: #fdecea; }
.menu-item--eliminar .menu-item-icono { background: #fde8e6; color: #c0392b; }
.menu-item--eliminar .menu-item-texto strong { color: #b03025; }
.menu-item--eliminar .menu-item-texto small { color: #e74c3c; }

/* Reabrir — azul */
.menu-item--reabrir:hover { background: #eff6ff; }
.menu-item--reabrir .menu-item-icono { background: #dbeafe; color: #0055cc; }
.menu-item--reabrir .menu-item-texto strong { color: #0055cc; }
.menu-item--reabrir .menu-item-texto small { color: #3b82f6; }

/* ═══════════════════════════════════════════════════
   TRANSITION: menu-slide
═══════════════════════════════════════════════════ */
.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.22s cubic-bezier(0.34, 1.4, 0.64, 1);
}
.menu-slide-enter,
.menu-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.96);
}
</style>
